import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import Autosuggest from "./../components/Autosuggest";
import { connect } from "react-redux";
import match from "autosuggest-highlight/match";
import parse from "autosuggest-highlight/parse";
import shortid from "shortid";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { taxServiceClient } from "../AxiosClient";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import LinearProgress from "@material-ui/core/LinearProgress";
import Tooltip from "@material-ui/core/Tooltip";
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import GroupIcon from '@material-ui/icons/Group';
import InfoIcon from '@material-ui/icons/Info';
import { Typography } from "@material-ui/core";
import "material-icons/iconfont/material-icons.css";
import Avatar from "@material-ui/core/Avatar";
import { withStyles } from "@material-ui/core/styles";
const styles = (theme) => ({
  portletFilterIssue: {
    display: "flex",
  },
  portletDetails: {
    marginLeft: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  portletDetailsTitle: {
    marginTop: 0,
    marginBottom: 0,
    paddingTop: 0,
    paddingBottom: 0,
  },
  avatar: {
    backgroundColor: theme.palette.primary.main,
  },
  unavailablePortletList: {
    marginTop: theme.spacing(0.5),
  }
})
export class TeamAutosuggest extends Component {
  state = {
    // instance: new Date().getTime().toString(),
    teams: [],
    orgId: this.props.organizationId,
    filteredPortlets:[],
  };

  componentDidMount() {
    let filteredPortlets = this.props.getListOfFilterTaxonomyIds ?
      this.props.getListOfFilterTaxonomyIds() : []
    let taxFilters = [...new Set(filteredPortlets.map(p => p.taxonomyIds).flat())]
    let url =
      filteredPortlets &&
      taxFilters.length > 0
        ? "/team/taxonomyfilter/full"
        : "/team/full";
    taxServiceClient
      .get(url, {
        params: {
          taxIds: taxFilters,
        },
      })
      .then((res) => {
        this.setState({ teams: res.data, filteredPortlets: filteredPortlets });
      });
  }

  render() {
    return (
      <div>
        {/* <Autosuggest
          // aria-label="prolly"
          // ariaLabel="prolly"
          // data={this.state.teams}
          // renderSuggestion={this.renderTeamSuggestion}
          // inputLabel={this.props.t("search_for_team")}
          keepSuggestion={this.keepTeamSuggestion}
          getSuggestionValue={this.getTeamSuggestionValue}
          clearOnSelect={this.props.clearOnSelect}
          // disabled={this.props.disabled}
        /> */}
        <Autocomplete
          getOptionLabel={(option) => {
            return option.available ||
              (this.state.filteredPortlets.length === 0)
              ? option.teamName
              : "";
          }}
          aria-label="prolly"
          ariaLabel="prolly"
          disabled={this.props.disabled}
          handleHomeEndKeys
          fullWidth
          openOnFocus
          options={this.state.teams}
          // onChange={(e, selected) => {
          //   this.props.onClick(selected);
          // }}
          getOptionSelected={(op, val) => {
            return (
              op.teamName === val.teamName && val.available 
            );
          }}
          renderOption={this.renderTeamSuggestion}
          // inputValue={this.state.value}
          // onInputChange={this.handleTopicSuggestChange}
          // getOptionLabel={(option) => option.topicName}
          renderInput={(params) => (
            <>
              <TextField
                {...params}
                variant="standard"
                label={this.props.t("search_for_team")}
              />{" "}
              {this.state.topicAutocompleteLoading && (
                <LinearProgress color="secondary" />
              )}
            </>
          )}
        />
      </div>
    );
  }

  onClick = (selectedUser) => {
    this.props.onItemSelected(selectedUser);
  };

  keepTeamSuggestion = (team, input) => {
    const inputLength = input.length;
    return team.teamName.slice(0, inputLength).toLowerCase() === input;
  };

  getTeamSuggestionValue = (suggestion) => {
    return suggestion.teamName;
  };

  renderTeamSuggestion = (suggestion, query, isHighlighted) => {
    const { classes, t } = this.props;
    const nameMatches = match(suggestion.teamName, query.inputValue);
    const nameParts = parse(suggestion.teamName, nameMatches);
    let unavailableTaxonomies = suggestion.unavailableTaxonomies && suggestion.unavailableTaxonomies.length > 0 
      ? suggestion.unavailableTaxonomies.map(u => u.taxonomyId)
      : []
    let getListOfFilterTaxonomyIds = unavailableTaxonomies.length > 0 ? 
      this.state.filteredPortlets.filter(p => {
        return p.taxonomyIds.some((t) => unavailableTaxonomies.includes(t))
      })
      : []
    let np = nameParts.map(
      (part) =>
        part.highlight ? (
          <span key={shortid.generate()} style={{ fontWeight: 500 }}>
            {part.text}
          </span>
        ) : (
          <strong key={shortid.generate()} style={{ fontWeight: 300 }}>
            {part.text}
          </strong>
        )
    );

    return (
      <Tooltip
        title={
          this.props.getListOfFilterTaxonomyIds &&
          getListOfFilterTaxonomyIds.length > 0 && (
            <>
              <Avatar aria-label="info" className={classes.avatar}>
                <span className="material-icons">
                  {"info_outline"}
                </span>
              </Avatar>
              <Typography>
                <>
                <div class={classes.portletDetails}>
                {`The ${suggestion.teamName} team is unavailable because this team cannot see the taxonomy
                filters on the following portlets:`}<br/>
                </div>
                {getListOfFilterTaxonomyIds.map(p => {
                  return (
                    <>
                      <div class={classes.portletFilterIssue}>
                        <Avatar aria-label="portlet" className={classes.avatar}>
                          <span className="material-icons">
                            {p.icon}
                          </span>
                        </Avatar>
                        <div class={classes.portletDetails}>
                          <p class={classes.portletDetailsTitle}>{`${p.title}`}</p>  
                          <p class={classes.portletDetailsTitle}>{`(row: ${p.y}, column: ${Math.ceil(p.x)})`}</p>
                        </div>
                      </div>
                      <ul class={classes.unavailablePortletList}>
                        {suggestion.unavailableTaxonomies.filter(u => p.taxonomyIds.includes(u.taxonomyId)).map(u => <li>{u.taxonomyName}</li>)}
                      </ul>
                    </>
                  )
                })}
                </>
              </Typography>
            </>
          )
        }
        disableHoverListener={
          suggestion.available ||
            getListOfFilterTaxonomyIds.length === 0
        }
      >
      <ListItem
          selected={isHighlighted}
          component="div"
          onClick={() =>
            (suggestion.available ||
                getListOfFilterTaxonomyIds.length === 0) &&
            this.onClick(suggestion)
          }
          disabled={
            !suggestion.available &&
            getListOfFilterTaxonomyIds.length === 0
          }
        >
          <ListItemAvatar>
              <GroupIcon color={suggestion.available === true ? "primary" : "disabled"}/>
          </ListItemAvatar>
          <ListItemText
            secondaryTypographyProps={{ noWrap: true }}
            primary={np}
          />
        </ListItem>
      </Tooltip>
    );
  };

  onClick = (team) => {
    this.props.onItemSelected(team);
  };
}

const mapStateToProps = (state) => ({
  message: state.websocket.message,
});

export default connect(
  mapStateToProps,
  null
)(withStyles(styles)(withTranslation()(TeamAutosuggest)));
